import { render, staticRenderFns } from "./SyllabellAppIcon.vue?vue&type=template&id=469991ab"
import script from "./SyllabellAppIcon.vue?vue&type=script&lang=ts"
export * from "./SyllabellAppIcon.vue?vue&type=script&lang=ts"
import style0 from "./SyllabellAppIcon.vue?vue&type=style&index=0&id=469991ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports